// extracted by mini-css-extract-plugin
module.exports = {"content":"_0fce717cdb--content--jmao_"};